import { DfyImageSelectionMode } from "@repo/api/dfy";
import { Checkbox } from "@/lib/components/Checkbox";
import { SELECTED_CARD_STYLE } from "../dfy-order-form-styles";

const OPTIONS: {
  id: DfyImageSelectionMode;
  name: string;
  description: string;
}[] = [
  {
    id: "EDITOR",
    name: "Amplifiles editors",
    description: "We choose and order the best images.",
  },
  {
    id: "USER",
    name: "I'll choose",
    description: "Choose and order the images yourself.",
  },
];

export default function ImageSelectionModeCard({
  mode,
  onSelect,
}: {
  mode: DfyImageSelectionMode;
  onSelect: (mode: DfyImageSelectionMode) => void;
}) {
  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm font-medium">
        Who chooses the images for the video?
      </p>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {OPTIONS.map((option) => {
          const isSelected = mode === option.id;
          return (
            <div
              key={option.id}
              onClick={() => onSelect(option.id)}
              className={`flex cursor-pointer items-center gap-4 rounded-xl border p-4 ${
                isSelected
                  ? "border-transparent"
                  : "hover:bg-button-outline-hover/40"
              }`}
              style={isSelected ? SELECTED_CARD_STYLE : undefined}
            >
              <div className="flex min-w-0 flex-1 flex-col">
                <span className="font-semibold">{option.name}</span>
                <span className="text-sm text-text-secondary">
                  {option.description}
                </span>
              </div>
              <Checkbox
                checked={isSelected}
                onCheckedChange={() => onSelect(option.id)}
                onClick={(e) => e.stopPropagation()}
                aria-label={option.name}
                className="shrink-0 rounded-full border-border-primary bg-transparent [&_svg]:size-3"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
